module.exports = __webpack_public_path__ + "static/media/mobile_zh-Hans.61183311.mp4";